import { TranslationsTypes } from '.';

export interface IVaultPasswordPolicyDTO {
    Id: string;
    TenantId: string;
    OrganizationId: string;
    DisplayName: string;
    LastModified: Date;
    IsDefault: boolean;
}

export interface IVaultPasswordPolicy {
    created: Date;
    createdBy: string;
    displayName: string;
    id: string;
    lastModified: Date;
    lastModifiedBy: string;
}

export enum RequirementTypes {
    uppercase = 'uppercase',
    lowercase = 'lowercase',
    digits = 'digits',
    specials = 'specials'
}

export interface IRequirementSwitch {
    type: RequirementTypes;
    label: TranslationsTypes;
    checked: boolean;
    tooltip?: TranslationsTypes;
}

export interface IVaultPasswordPolicyRequirements {
    value: string;
    label: string;
    MinimumLength: number;
    MaximumLength: number;
    SpecialCharactersUsed: string;
    OnlyNumbers: boolean;
    RequireDigits: boolean;
    RequireUppercase: boolean;
    RequireLowercase: boolean;
    RequireSpecials?: boolean;
}